import axios from 'axios'

const baseURL = process.env.VUE_APP_ADMIN_SERVER + '/api/users'

export default {
  namespaced: true,
  state: {
    is_loading: null,
    is_processing: null,
    workers: []
  },
  mutations: {
    setWorkers (state, payload) {
      state.workers = payload
    },
    removeWorkerItem (state, id) {
      const index = state.workers.findIndex(item => item.id === id)

      if (index !== -1) {
        state.workers.splice(index, 1)
      }
    }
  },
  actions: {
    async getWorkers ({ commit, state }) {
      state.is_loading = true
      const promise = axios.get(baseURL)

      promise.then(response => {
        commit('setWorkers', response.data.data)
        state.is_loading = false
      })
    },
    async getWorker ({ commit, state }, id) {
      state.is_loading = true
      const promise = axios.get(baseURL + '/' + id)

      promise.then(response => {
        state.is_loading = false
      })

      return promise
    },
    async createWorker ({ commit, state }, data) {
      state.is_processing = true
      const promise = axios.post(baseURL, data)

      promise.then(() => {
        state.is_processing = false
      }).catch(() => {
        state.is_processing = false
      })

      return promise
    },
    async updateWorker ({ commit, state }, data) {
      state.is_processing = true
      const promise = axios.put(baseURL + '/' + data.id, data)

      promise.then(() => {
        state.is_processing = false
      }).catch(() => {
        state.is_processing = false
      })

      return promise
    },
    async deleteWorker ({ commit, state }, id) {
      state.is_processing = true
      const promise = axios.delete(baseURL + '/' + id)

      promise.then(() => {
        state.is_processing = false
        commit('removeWorkerItem', id)
      }).catch(() => {
        state.is_processing = false
      })

      return promise
    }
  }
}
